import { CSSProperties, ReactNode } from 'react';
import { Drawer, Modal } from 'antd';
import { styled } from 'styled-components';

import { useIsMobile } from '@hooks/index';
import { If } from '@components/condition';
import { X } from 'lucide-react';

interface IProps {
  visible: boolean;
  onCancel: () => void;
  children: ReactNode;
  bodyStyle?: CSSProperties;
  width?: number;
  title?;
  closable?: boolean;
  className?: string;
  breakPoint?: number;
  borderHeader?: boolean;
  center?: boolean;
  maskClosable?: boolean;
  destroyOnClose?: boolean;
  paddingContent?: boolean;
  zIndex?: number;
}

const ModalStyled = styled(Modal)<{ $isHeader?: boolean; $paddingContent?: boolean }>`
  .ant-modal-content {
    border-radius: 8px !important;
    overflow: hidden !important;
  }
  .ant-modal-header {
    border: none !important;
  }
  .ant-modal-header::after {
    content: '';
    display: flex;
    width: 100%;
    height: ${(props) => (props.$isHeader ? '1px' : '0px')};
    background-color: ${(props) => (props.$isHeader ? '#F4F4F6' : 'none')};
    position: relative;
    top: 16px;
  }
  .ant-modal-body {
    padding: ${(props) => (props.$paddingContent ? '24px 0px !important' : '0px !important')};
  }
`;

export function DrawerBottom({
  visible = false,
  onCancel,
  children,
  bodyStyle,
  width,
  title,
  closable,
  className = '',
  breakPoint = 1024,
  borderHeader = false,
  center = false,
  maskClosable = true,
  destroyOnClose = true,
  paddingContent = true,
  zIndex = null,
}: IProps) {
  const isMobile = useIsMobile(breakPoint);
  return (
    <If
      condition={!isMobile}
      Then={
        <ModalStyled
          zIndex={zIndex}
          $isHeader={borderHeader}
          $paddingContent={paddingContent}
          destroyOnClose={destroyOnClose}
          className={className}
          styles={{ body: { padding: 0, backgroundColor: '#0000', ...bodyStyle } }}
          title={title}
          open={visible}
          footer={null}
          closable={closable || null}
          onCancel={onCancel}
          width={width ? width : 800}
          centered={center}
          modalRender={(modal) => <div className="w-full">{modal}</div>}
          maskClosable={maskClosable}
        >
          {children}
        </ModalStyled>
      }
      Else={
        <Drawer
          zIndex={zIndex}
          destroyOnClose={destroyOnClose}
          title={title}
          height="auto"
          placement="bottom"
          closable={false}
          onClose={onCancel}
          open={visible}
          maskClosable={maskClosable}
          className="rounded-t-md"
          extra={
            <button onClick={onCancel} className="!text-gray-700 !font-semibold">
              <X />
            </button>
          }
          styles={{
            header: {
              padding: '16px',
              borderBottom: '1px solid #f0f0f0',
            },
            body: {
              padding: '16px',
            },
          }}
        >
          {children}
        </Drawer>
      }
    />
  );
}
